import { ref, onMounted, onUnmounted } from 'vue';

// Crea un oggetto per gestire gli eventi
const eventBus = {
  events: {},
  
  // Metodo per registrare un evento
  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  },
  
  // Metodo per rimuovere un evento
  off(event, callback) {
    if (!this.events[event]) return;
    
    if (callback) {
      this.events[event] = this.events[event].filter(cb => cb !== callback);
    } else {
      delete this.events[event];
    }
  },
  
  // Metodo per emettere un evento
  emit(event, ...args) {
    if (!this.events[event]) return;
    
    this.events[event].forEach(callback => {
      callback(...args);
    });
  }
};

// Funzioni composable per usare l'eventBus nei componenti Vue
export function useEventListener(event, callback) {
  onMounted(() => {
    eventBus.on(event, callback);
  });
  
  onUnmounted(() => {
    eventBus.off(event, callback);
  });
}

export function useEventEmitter() {
  return {
    emit: (event, ...args) => eventBus.emit(event, ...args)
  };
}

export default eventBus;
